var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.704 28.312h2.65L30 16.702l-4.89-3.697-4.294 2.8v4.966l-3.285 3.137V25.4l3.174 2.912zm-7.84-12.507-.485 4.667h7.241l-.447-4.667 1.568-4.18H11.26l1.604 4.18zM11.37 28.35l3.174-2.95v-1.493L11.26 20.77v-4.965l-4.332-2.762L2 16.7l6.683 11.65h2.688zM23.318 3H8.645l-1.717 7.467h18.144L23.317 3z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro);
export default __webpack_public_path__ + "static/media/CRO.0399595cfb0921b153c59247f9613cea.svg";
export { ForwardRef as ReactComponent };